module.exports = __webpack_public_path__ + "static/img/5.61a07d6b.png";